// Shared regeneration-selection logic used by BOTH Home and PlanningHub so the
// two screens can never diverge again on how linked leftover meals are handled.
//
// Backend rule (unchanged, already shipped): a cook/leftover row whose partner
// is outside the regeneration range is force-kept and its recipe excluded from
// re-selection. The UI must therefore treat every linked (cook/leftover) row as
// protected/kept and only replace it via the pair-safe Replace Both flow.

// True when the plan row is part of a leftover pair (cook or leftover).
export function isLinkedRow(plan) {
  return !!plan && (plan.leftover_role === 'cook' || plan.leftover_role === 'leftover');
}

// Build the /smart-fill/auto request selection from the plan rows in the
// regeneration range and the user's MANUAL keep selection (plan_ids the user
// explicitly checked).
//   - mealsToKeep: manual keeps + all linked (cook/leftover) rows, merged/deduped
//                  (null when empty so the backend default applies)
//   - excludeMealIds: meal_ids of every non-skipped row NOT in the keep set
//                     (linked rows are kept, so they are never excluded)
// Returns { mealsToKeep: string[]|null, excludeMealIds: string[], linkedKeepIds: string[] }.
export function buildRegenSelection(dayMeals, manualKeepIds) {
  var meals = dayMeals || [];
  var manual = manualKeepIds || [];

  var linkedKeepIds = [];
  meals.forEach(function (p) {
    if (p && p.status !== 'skipped' && isLinkedRow(p) && p.plan_id) {
      linkedKeepIds.push(p.plan_id);
    }
  });

  var effectiveKeep = manual.slice();
  linkedKeepIds.forEach(function (id) {
    if (id && effectiveKeep.indexOf(id) === -1) effectiveKeep.push(id);
  });

  var excludeMealIds = [];
  meals.forEach(function (p) {
    if (p && p.status !== 'skipped' && effectiveKeep.indexOf(p.plan_id) === -1) {
      excludeMealIds.push(p.meal_id);
    }
  });

  return {
    mealsToKeep: effectiveKeep.length > 0 ? effectiveKeep : null,
    excludeMealIds: excludeMealIds,
    linkedKeepIds: linkedKeepIds,
  };
}
